import React, { useContext, useEffect, useState } from "react";

import Modal from "../Modal/Modal";
import styles from "./AvatarGeneration.module.scss";
import Camera from "../Camera/Camera";
import { AvatarContext } from "../../../../contexts/AvatarContext/AvatarContextProvider";
import ProfileScreen from "../ProfileScreen";
import axios from "axios";
import AvatarInitialScreen from "../AvatarInitialScreen";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { uploadAvatarImages } from "../../../../Managers/Avatar";
import AvatarManager from "../../../../Managers/Users/Avatar";
import LoaderImg from "../../../../assets/images/Loader.gif";

const AvatarGeneration = ({ handleCloseAvatar }) => {
  const { state, handleScreen, addDetails, handleSave, handleLoading } =
    useContext(AvatarContext);
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [imgSrc, setImgSrc] = useState(false);

  const handleSetImgSrc = (value) => {
    setImgSrc(value);
  };

  const UploadImage = async () => {
    let res = await uploadAvatarImages(
      imgSrc,
      "cam_image",
      user.uid,
      (res) => {}
    );
    setImgSrc(res);

    addDetails("cam_image", res);
    return res;

    // UserAvatarDetails["key"] = "avatar";
  };

  const handleImageSave = async () => {
    handleLoading(true);
    let res = "";
    if (state.cam_image) {
      res = state.cam_image;
    } else {
      res = await UploadImage();
    }
    handleSave("Image", { id: "cam_img", img: res });

    handleCloseAvatar();
  };

  const handleGenerateAvatar = async () => {
    setLoading(true);

    // const headers = {
    //   "Content-Type": "application/json;charset=UTF-8",
    //   "Access-Control-Allow-Origin": "*",
    // };
    // const Obj = {
    //   photo: imgSrc.replace(/^data:image\/png;base64,/, ""),
    //   // photo: imgSrc,
    // };

    // // let form = new FormData();
    // // form.append("photo", imgSrc.replace(/^data:image\/png;base64,/, ""));

    // await axios
    //   .post("http://localhost:3002/uploadPhoto", Obj, {
    //     headers,
    //   })
    //   .then((res) => {
    //     console.log(res);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
    UploadImage();
    setLoading(false);
    handleScreen("screen", "showAvatarScreen");
  };

  return (
    <Modal handleCloseAvatar={handleCloseAvatar}>
      {loading ? (
        <div className={styles.loadingWrapper}>
          <h1>Generating your Avatar </h1>
          <p>Please wait..</p>
        </div>
      ) : state.screen === "showAvatarScreen" ? (
        <ProfileScreen
          camImage={imgSrc}
          handleCloseAvatar={handleCloseAvatar}
        />
      ) : state.screen === "showCameraScreen" ||
        state.screen === "showRetakeScreen" ||
        state.screen === "showProfileScreen" ? (
        <div className={styles.container}>
          {state.screen !== "showProfileScreen" && (
            <div className={styles.header}>
              Click image to generate your Avatar
            </div>
          )}
          <Camera handleSetImgSrc={handleSetImgSrc} />
          {state.screen === "showProfileScreen" ? (
            <div className={styles.btnsWrapper}>
              <button
                disabled={state.loading}
                onClick={() => handleImageSave()}
                className={`btn ${styles.btn}`}
              >
                {state.loading ? (
                  <img src={LoaderImg} alt="" height="100%" />
                ) : (
                  "Save"
                )}
              </button>
              <button
                className={`btn ${styles.btn}`}
                onClick={() => {
                  handleGenerateAvatar();
                  // handleGenerateAvatar();
                  // handleScreen("showAvatarScreen", true);
                }}
              >
                Generate Avatar
              </button>
            </div>
          ) : (
            <button
              disabled={state.screen !== "showRetakeScreen"}
              className={`btn ${styles.btn}`}
              onClick={() => {
                // handleGenerateAvatar();
                handleScreen("screen", "showProfileScreen");
              }}
            >
              Next
            </button>
          )}
        </div>
      ) : (
        <AvatarInitialScreen
          handleGenerateAvatar={handleGenerateAvatar}
          handleCloseAvatar={handleCloseAvatar}
        />
      )}
    </Modal>
  );
};

export default AvatarGeneration;

{
  /* <div className={styles.avatarBtnWrapper}>
<button className={`btn ${styles.btn}`}>Edit Profile</button>
<button
  onClick={handleAvatarNext}
  className={`btn ${styles.btn}`}
>
  Next
</button>
</div> */
}
